class ComponentRichText extends HTMLElement {
  constructor() {
    super();
    this.shouldExpand = this.classList.contains("has-more");
    this.buttonMore = this.querySelector("button");
  }

  connectedCallback() {
    if (!this.shouldExpand) return;
    this.buttonMore?.addEventListener("click", this.onExpand.bind(this));
  }

  onExpand(event) {
    event.preventDefault();
    this.classList.remove("has-more");
  }
}

customElements.define("component-richtext", ComponentRichText);
